const __modelMeta__ = Symbol();

export { __modelMeta__ };
//# sourceMappingURL=symbol.mjs.map
